<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'alunos' })"
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Aluno
        </h1>
      </v-col>
    </v-row>
    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitForm)" :disabled="submittingForm">
        <v-row>
          <v-col class="pt-0 pb-0" cols="8">
            <ValidationProvider name="Nome completo" rules="required" v-slot="{ errors }">
              <e-label>Nome completo</e-label>
              <v-text-field :error-messages="errors" v-model="form.nomecompleto" dense solo />
            </ValidationProvider>
          </v-col>

          <v-col class="pt-0 pb-0" cols="4">
            <ValidationProvider name="CPF" rules="cpf" v-slot="{ errors }">
              <e-label>Número do CPF</e-label>
              <v-text-field
                v-mask="'###.###.###-##'"
                v-model="form.cpf"
                :error-messages="errors"
                :loading="verificandoCpf"
                :error="cpfJaExiste"
                @blur="verificarCpfExistente"
                dense
                solo
              />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <ValidationProvider name="Código do INEP" v-slot="{ errors }">
              <e-label>Identificação única(INEP)</e-label>
              <v-text-field
                ref="inepField"
                :error-messages="errors"
                v-model="form.codigo_inep"
                :loading="pesquisandoINEP"
                dense
                solo
                v-mask="'############'"
                :required="!form.inep_status"
                :rules="[
                  !form.inep_status ? (v) => !!v || 'Preenchimento obrigatório do INEP' : '',
                ]"
                :readonly="form.inep_status || (editing && !inepEditing)"
                @click:append-outer="toggleInepEditing"
              >
                <template v-slot:append-outer v-if="editing">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" @click="toggleInepEditing">
                        {{ inepEditing ? "mdi-check" : "mdi-pencil" }}
                      </v-icon>
                    </template>
                    <span>Editar INEP</span>
                  </v-tooltip>
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-col>
          <v-col>
            <v-switch cols="2" v-model="form.inep_status" :input-value="form.codigo_inep !== ''">
              <template v-slot:label>Aluno sem INEP</template>
            </v-switch>
          </v-col>
          <v-col class="pt-0 pb-0" cols="5">
            <e-label>Data de nascimento</e-label>
            <!-- <v-text-field :error-messages="errors" v-model="form.data_nascimento" dense solo /> -->
            <ValidationProvider name="Data de nascimento" rules="required" v-slot="{ errors }">
              <e-date-picker
                :error-messages="errors"
                v-model="form.data_nascimento"
                placeholder="dd/mm/yyyy"
              ></e-date-picker>
            </ValidationProvider>
          </v-col>

          <v-col class="pt-0 pb-0" cols="6">
            <ValidationProvider name="Filiação 1" rules="required" v-slot="{ errors }">
              <e-label>Filiação 1</e-label>
              <v-text-field :error-messages="errors" v-model="form.filiacao1" dense solo />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <e-label>Profissão (Filiação 1)</e-label>
            <v-text-field v-model="form.profissao_filiacao1" dense solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <e-label>Filiação 2</e-label>
            <v-text-field v-model="form.filiacao2" dense solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <e-label>Profissão (Filiação 2)</e-label>
            <v-text-field v-model="form.profissao_filiacao2" dense solo />
          </v-col>

          <v-col class="pt-0 pb-0" cols="6">
            <e-label>Gênero </e-label>
            <e-autocomplete
              :items="$constants.sexoList"
              :return-object="false"
              :item-value="(value) => value.id"
              :item-text="(value) => value.descricao"
              v-model="form.sexo_id"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <e-label>Cor/Raça</e-label>
            <e-autocomplete
              :items="$constants.corOuRacaList"
              :return-object="false"
              v-model="form.cor_ou_raca"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <e-label>Nacionalidade</e-label>
            <e-autocomplete
              :items="$constants.nacionalidadeList"
              :return-object="false"
              :item-text="(value) => value"
              :item-value="(value) => value"
              v-model="form.naturalidade"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <e-label>País de nacionalidade</e-label>
            <v-text-field v-model="form.nacionalidade" dense solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <e-label>UF de nascimento</e-label>
            <e-autocomplete
              :items="$constants.estadosList"
              :return-object="false"
              :item-text="(item) => item.codigo"
              :item-value="(item) => item.codigo"
              v-model="form.estadualidade"
              @change="(event) => atualizarEstado(event)"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <e-label>Município de nascimento</e-label>
            <e-autocomplete
              :items="municipiosNasc"
              :return-object="false"
              :item-text="(item) => item"
              :item-value="(item) => item"
              v-model="form.municipalidade"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>

          <v-col class="pt-0 pb-0" cols="12">
            <e-label
              >Aluno(a) com deficiência, transtorno do espectro autista ou altas
              habilidades/superdotação</e-label
            >
            <v-switch v-model="form.especial"></v-switch>
          </v-col>
          <template v-if="form.especial">
            <v-col cols="12">
              <h4>
                Tipo de deficiência, transtorno do espectro autista ou altas
                habilidades/superdotação
              </h4>
            </v-col>
            <v-col class="pt-0 pb-0" cols="4">
              <e-label>Deficiência</e-label>

              <e-autocomplete
                clearable
                :items="$constants.tipoDeDeficienciaList"
                :return-object="false"
                v-model="form.tipos_de_deficiencia"
                label="Selecione uma opção"
                multiple
                dense
                solo
              />
            </v-col>
            <v-col class="pt-0 pb-0" cols="4">
              <e-label>Transtorno do espectro autista</e-label>

              <e-autocomplete
                clearable
                :items="$constants.tipoDeTranstornoDoEspectroAutistaList"
                :return-object="false"
                v-model="form.tipos_de_transtornos"
                label="Selecione uma opção"
                multiple
                dense
                solo
              />
            </v-col>

            <v-col class="pt-0 pb-0" cols="4">
              <e-label>Altas habilidades/superdotação</e-label>

              <e-autocomplete
                clearable
                :items="$constants.tipoDeAltasHabilidadesList"
                :return-object="false"
                v-model="form.tipos_de_altas_habilidades"
                label="Selecione uma opção"
                multiple
                dense
                solo
              />
            </v-col>
          </template>

          <v-col v-if="form.especial" class="mb-6">
            <e-label>Laudo Infantil</e-label>
            <div class="dropboxStyles">
              <input id="fileUpload" class="input-file-upload" type="file" @change="selectFile" />
              <span v-if="!pdf" style="cursor: pointer">Upload</span>

              <span v-if="pdf">
                <v-chip v-if="pdf" class="ma-2" color="green" label text-color="white">
                  {{ pdf.target.files[0].name }}
                </v-chip>
              </span>

              <span v-if="form?.laudo && !pdf">
                <v-chip
                  v-if="form?.laudo && !pdf"
                  class="ma-2"
                  color="green"
                  label
                  text-color="white"
                >
                  {{ form?.laudo }}
                </v-chip>
              </span>

              <span v-if="pdf">
                <v-btn v-if="pdf" class="mx-2" fab dark small color="red" @click="apagarLaudo">
                  <v-icon dark> mdi-close </v-icon>
                </v-btn>
              </span>

              <span v-if="form.laudo">
                <v-btn
                  v-if="form.laudo"
                  class="mx-2"
                  fab
                  dark
                  small
                  color="red"
                  @click="apagarLaudoForm"
                >
                  <v-icon dark> mdi-close </v-icon>
                </v-btn>
              </span>

              <span v-if="form.laudo">
                <v-btn
                  v-if="form.laudo"
                  class="mx-2"
                  fab
                  dark
                  small
                  color="red"
                  @click="downloadLaudo"
                >
                  <v-icon dark> mdi-download </v-icon>
                </v-btn>
              </span>
            </div>
          </v-col>

          <v-col class="pt-0 pb-0" cols="12">
            <h4>
              Recursos para uso do(a) aluno(a) em sala de aula e para participação em avaliações do
              Inep (Saeb)
            </h4>
            <v-row class="">
              <v-col
                class="pt-0 pb-0"
                cols="4"
                v-for="(el, index) of $constants.recursosSaebList"
                :key="index"
              >
                <v-checkbox v-model="recursos_saeb[index]" :label="el" :value="el"></v-checkbox>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <h4>DOCUMENTO</h4>
          </v-col>
          <v-col class="pt-0 pb-0" cols="5">
            <e-label> Número de Identificação Social (NIS) </e-label>
            <v-text-field v-model="form.numero_nis" dense solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="7">
            <e-label> Número da matrícula da certidão de nascimento (certidão nova) </e-label>
            <v-text-field v-model="form.matricula_certidao_de_nascimento" dense solo />
          </v-col>
          <v-col cols="12">
            <h4>DADOS SOBRE A ÁREA RESIDENCIAL DO(A) ALUNO(A)</h4>
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <e-label> País de residência </e-label>
            <v-text-field v-model="form.pais_residencia" dense solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label> CEP </e-label>
            <v-text-field v-mask="`#####-###`" v-model="form.cep" dense solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="2">
            <e-label> UF </e-label>
            <e-autocomplete
              :items="$constants.estadosList"
              :return-object="false"
              :item-text="(item) => item.codigo"
              :item-value="(item) => item.codigo"
              v-model="form.uf_residencia"
              @change="(event) => atualizarEstadoRes(event)"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="3">
            <e-label> Endereço </e-label>
            <v-text-field v-model="form.endereco" dense solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="3">
            <e-label> Número </e-label>
            <v-text-field v-model="form.numero" dense solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="3">
            <e-label> Bairro </e-label>
            <v-text-field v-model="form.bairro" dense solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="3">
            <e-label> Complemento </e-label>
            <v-text-field v-model="form.complemento" dense solo />
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <e-label> Município de residência </e-label>
            <e-autocomplete
              :items="municipiosRes"
              :return-object="false"
              :item-text="(item) => item"
              :item-value="(item) => item"
              v-model="form.municipio_residencia"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <e-label> Zona de Residência </e-label>
            <e-autocomplete
              :items="$constants.zonaResidenciaList"
              :return-object="false"
              v-model="form.zona_residencia"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <e-label>Localização diferenciada de residência</e-label>
            <e-autocomplete
              :items="$constants.localizacaoDiferenciadaDeResidenciaList"
              :return-object="false"
              v-model="form.zona_diferenciada_residencia"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="6">
            <e-label>Transporte escolar público </e-label>
            <v-switch
              v-model="form.utiliza_transporte_publico"
              color="primary"
              :label="form.utiliza_transporte_publico ? 'Utiliza' : 'Não utiliza'"
              hide-details
            ></v-switch>
          </v-col>

          <v-col class="pt-0 pb-0" cols="3" v-if="form.sexo_id === 2">
            <e-label>Gravidez na Adolescência?</e-label>
            <v-combobox
              id="input-gravidez-adolescencia"
              v-model="form.gravidez_adolescencia"
              :items="itemsEscolhas"
              label="Selecione uma opção"
              dense
              solo
            ></v-combobox>
          </v-col>

          <v-col class="pt-9 pb-0" cols="9">
            <v-row v-show="true" style="min-height: 56px">
              <v-col cols="6" v-show="form.gravidez_adolescencia === 'Sim'">
                <e-label id="obs-gravidez-adolescencia"></e-label>
              </v-col>
            </v-row>
          </v-col>

          <e-uploads-images
            :dadosImgCarteira="imgCarteiraUrl"
            :dadosImgAluno="imgAlunoUrl"
            @imagem-aluno-form="atualizarImagemAluno($event)"
            @imagem-carteira-form="atualizarImagemCarteira($event)"
          />

          <template>
            <v-col cols="12" md="6">
              <v-btn
                color="primary"
                :disabled="submittingForm || cpfJaExiste"
                :loading="submittingForm && saveAction === 'sair'"
                @click="submitFormWithAction('sair')"
                block
              >
                <v-icon left>fa fa-save</v-icon>
                Salvar e Sair
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" v-if="!alunoTemMatricula">
              <v-btn
                color="success"
                :disabled="submittingForm || cpfJaExiste"
                :loading="submittingForm && saveAction === 'matricular'"
                @click="submitFormWithAction('matricular')"
                block
              >
                <v-icon left>fa fa-graduation-cap</v-icon>
                Salvar e Matricular
              </v-btn>
            </v-col>
          </template>
        </v-row>
      </form>
      <CpfDuplicadoModal
        :visible="mostrarModalCpfDuplicado"
        :tipo="cpfTipoEncontrado"
        :nome="
          cpfDadosEncontrados?.nomecompleto ||
          cpfDadosEncontrados?.nome ||
          cpfDadosEncontrados?.name
        "
        contexto="aluno"
        @close="fecharModalCpf"
      />
    </ValidationObserver>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import ELabel from "../../components/ELabel.vue";
import EUploadsImages from "../../components/Alunos/EUploadsImages.vue";
import CpfDuplicadoModal from "../../components/CpfDuplicadoModal.vue";

const STATUS_INITIAL = 0;
const STATUS_SAVING = 1;
const STATUS_SUCCESS = 2;
const STATUS_FAILED = 3;

export default {
  components: { ELabel, EUploadsImages, CpfDuplicadoModal },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    "form.codigo_inep": function (newVal, oldVal) {
      // if (newVal) {
      //   this.form.inep_status = false;
      // } else {
      //   this.form.inep_status = true;
      // }

      // Debounce: agendar verificação somente quando o campo codigo_inep realmente mudar
      if (this.nextInepTimeoutCall) {
        clearTimeout(this.nextInepTimeoutCall);
        this.nextInepTimeoutCall = null;
      }

      if (newVal && newVal !== oldVal) {
        this.nextInepTimeoutCall = setTimeout(() => {
          this.verificarCodigoINEP();
        }, 500);
      }
    },
    "form.inep_status": function (newVal) {
      if (newVal) {
        this.form.codigo_inep = null;
      }
    },
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
    selected() {
      return this.form.selected;
    },
    ...mapGetters("Auth", ["user"]),
  },

  mounted() {
    this.reset();
    this.loadFormData();
  },

  data() {
    return {
      pdf: null,
      submittingForm: false,
      saveAction: null,
      recursos_saeb: [],
      form: {
        naturalidade: "Brasileira",
      },
      nextInepTimeoutCall: null,
      pesquisandoINEP: false,
      municipiosNasc: [],
      municipiosRes: [],
      edit: true,
      imgAlunoUrl: null,
      imgAlunoName: null,
      imgCarteiraUrl: null,
      imgCarteiraName: null,
      file_upload: null,
      currentStatus: null,
      cpfJaExiste: false,
      mostrarModalCpfDuplicado: false,
      cpfTipoEncontrado: "",
      cpfDadosEncontrados: null,
      verificandoCpf: false,
      itemsEscolhas: ["Sim", "Não"],
      gravidez_adolescencia: null,
      alunoTemMatricula: false,
      inepEditing: false,
    };
  },

  methods: {
    atualizarEstado(value) {
      if (value) {
        this.municipiosNasc = this.$constants.municipios[value].cidades;
      }
    },

    atualizarEstadoRes(value) {
      if (value) {
        this.municipiosRes = this.$constants.municipios[value].cidades;
      }
    },

    apagarLaudo() {
      document.querySelector("#fileUpload").value = "";
      this.pdf = null;
    },

    apagarLaudoForm() {
      document.querySelector("#fileUpload").value = "";
      this.pdf = null;
      this.form.laudo = null;
    },

    async selectFile(event) {
      const file = event?.target?.files[0];
      if (!file) return;

      // Verifica tipo
      if (file.type !== "application/pdf") {
        this.$toast.danger("Formato de arquivo inválido. Envie um PDF.");
        document.querySelector("#fileUpload").value = "";
        return;
      }

      // Verifica tamanho (4MB)
      const maxSize = 4 * 1024 * 1024;
      if (file.size > maxSize) {
        this.$toast.danger("O arquivo não pode ser maior que 4MB.");
        document.querySelector("#fileUpload").value = "";
        return;
      }

      // Se o aluno já existir, envie imediatamente para validação/armazenamento
      if (this.form && this.form.id) {
        // Renomear arquivo para um nome aleatório terminando em .pdf antes do upload
        let randomName = null;
        try {
          if (typeof crypto !== "undefined" && crypto.randomUUID) {
            randomName = `${crypto.randomUUID()}.pdf`;
          } else if (
            typeof window !== "undefined" &&
            window.crypto &&
            window.crypto.getRandomValues
          ) {
            // fallback simples
            randomName = `${Date.now()}-${Math.floor(Math.random() * 1000000)}.pdf`;
          } else {
            randomName = `${Date.now()}-${Math.floor(Math.random() * 1000000)}.pdf`;
          }
        } catch (e) {
          randomName = `${Date.now()}-${Math.floor(Math.random() * 1000000)}.pdf`;
        }

        const renamedFile = new File([file], randomName, { type: file.type });

        const formData = new FormData();
        formData.append("file", renamedFile);
        this.currentStatus = STATUS_SAVING;
        try {
          const resp = await this.$services.alunosService.uploadLaudo(formData, this.form.id);
          if (resp && resp.data) {
            this.form.laudo = resp.data.laudo || resp.data.nameFile || this.form.laudo;
            this.pdf = null;
            this.$toast.success(resp.data.message || "Laudo salvo com sucesso");
          }
        } catch (uploadError) {
          const data = uploadError?.response?.data;
          if (data?.errors) {
            Object.values(data.errors).forEach((arr) => {
              if (Array.isArray(arr)) arr.forEach((msg) => this.$toast.danger(msg));
            });
          } else if (data?.message) {
            this.$toast.danger(data.message);
          } else {
            this.$toast.danger("Erro ao enviar o laudo.");
          }
          document.querySelector("#fileUpload").value = "";
        } finally {
          this.currentStatus = STATUS_INITIAL;
        }

        return;
      }

      // Caso de criação: apenas armazena o evento para upload posterior e informa que passou na validação básica
      this.pdf = event;
      // this.$toast.success("Arquivo válido. Será enviado ao salvar o aluno.");
    },
    toggleInepEditing() {
      // Só permite alterar o modo se estivermos em modo de edição da página
      if (!this.editing) return;

      // Alterna o modo de edição do campo INEP. Se ativado, foca o campo.
      this.inepEditing = !this.inepEditing;
      this.$nextTick(() => {
        if (this.inepEditing && this.$refs.inepField) {
          this.$refs.inepField.focus();
        }
      });
    },
    async verificarMatricula() {
      if (!this.form.id) {
        this.alunoTemMatricula = false;
        return;
      }

      const qtdMatriculas = await this.$services.alunosService.matriculasAlunoNoAno(this.form.id);

      this.alunoTemMatricula = qtdMatriculas > 0;
    },

    async pegarAluno() {
      try {
        const { aluno_id } = this.$route.params;
        const aluno = await this.$services.alunosService.pegarAluno(aluno_id);
        return aluno;
      } catch (error) {
        return this.$handleError(error);
      }
    },

    async downloadLaudo() {
      try {
        const { aluno_id } = this.$route.params;
        const data = await this.$services.alunosService.downloadLaudo(aluno_id);
        return data;
      } catch (error) {
        return this.$handleError(error);
      }
    },

    async submitFormWithAction(action) {
      this.saveAction = action;

      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        this.saveAction = null;
        return;
      }

      await this.submitForm();
    },

    async submitForm() {
      if (this.cpfJaExiste) {
        this.$toast.danger("Este CPF já está cadastrado no sistema.");
        return;
      }

      this.form.especial = Boolean(this.form.especial);
      this.form.recursos_saeb = this.recursos_saeb;
      this.submittingForm = true;
      this.form.image_carteira = this.imgCarteiraName;
      this.form.imagem = this.imgAlunoName;

      try {
        let alunoResponse = null;
        if (this.editing) {
          alunoResponse = await this.$services.alunosService.atualizarAluno(this.form);
          if (this.pdf) {
            const formData = new FormData();
            formData.append("file", this.pdf.target.files[0]);
            await this.$services.alunosService.uploadLaudo(formData, this.form.id);
          }

          this.$toast.success("Aluno(a) atualizado com sucesso");
          this.$router.push({ name: "alunos" });
        } else {
          alunoResponse = await this.$services.alunosService.criarAluno(this.form);

          if (this.pdf) {
            if (alunoResponse) {
              const formData = new FormData();
              formData.append("file", this.pdf.target.files[0]);
              await this.$services.alunosService.uploadLaudo(formData, alunoResponse.id);
            }
          }

          this.$toast.success("Aluno criado com sucesso");
        }
        if (this.saveAction === "matricular") {
          this.$loaderService.open("Você será direcionado para a tela de matrículas");

          setTimeout(() => {
            this.$router.push({
              name: "matriculas.create",
              query: { aluno_id: alunoResponse.id },
            });
          }, 300);
        } else {
          this.$router.push({ name: "alunos" });
        }
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.submittingForm = false;
        this.saveAction = null;
      }
    },
    async loadFormData() {
      const aluno = await this.pegarAluno();
      if (aluno) {
        this.edit = false;
        if (aluno.codigo_inep) {
          this.form.inep_status = false;
        }
      }
      this.atualizarEstadoRes(aluno.uf_residencia);
      this.atualizarEstado(aluno.estadualidade);
      if (aluno.imagem) {
        this.currentStatus = STATUS_SAVING;
      }
      this.recursos_saeb = aluno.recursos_saeb ?? [];

      this.form = {
        ...aluno,
      };

      if (this.form.image_carteira) {
        this.imgCarteiraUrl = `${process.env.VUE_APP_API_HOST}carteira-vacina/uploads/${this.form.image_carteira}`;
        this.imgCarteiraName = this.form.image_carteira;
      }

      if (this.form.imagem) {
        this.imgAlunoUrl = `${process.env.VUE_APP_API_HOST}imagem-do-aluno/uploads/${this.form.imagem}`;
        this.imgAlunoName = this.form.imagem;
      }
      await this.verificarMatricula();
    },

    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },

    filesChange(fileList) {
      if (!fileList.length) return;

      this.base64Img = "";

      const reader = new FileReader();

      reader.onload = (event) => {
        this.base64Img = event.target.result;
      };

      reader.readAsDataURL(fileList[0]);

      if (fileList.length > 1) {
        this.countImagem = true;
        setTimeout(() => {
          this.countImagem = false;
        }, 4000);
      }
      Array.from(Array(fileList.length).keys()).map((x) => {
        this.imageAluno = fileList[x];
        return fileList[x];
      });

      this.currentStatus = STATUS_SAVING;
    },

    async verificarCodigoINEP() {
      if (!this.form.codigo_inep) return;
      // Em edição, só verificar se o usuário entrou no modo de editar o INEP
      if (this.editing && !this.inepEditing) return;
      this.pesquisandoINEP = true;
      try {
        const aluno = await this.$services.alunosService.getAlunoComINEP(this.form.codigo_inep);
        if (aluno) {
          if (aluno.configuracao_id !== this.user.configuracao_id) {
            this.$modals.warn({
              title: "Você gostaria de transferir esse(a) aluno(a)?",
              message: `Encontramos o(a) aluno(a) <strong>${aluno.nomecompleto}</strong> com INEP <strong>${aluno.codigo_inep}</strong> registrado em outra escola, você gostaria de transferí-lo para sua escola?`,
              buttons: [
                {
                  text: "Cancelar",
                  callback: () => {
                    this.$modals.close();
                  },
                  props: {
                    color: "warning",
                    small: true,
                  },
                },
                {
                  text: "Confirmar",
                  callback: async () => {
                    this.$modals.setOptions({ loading: true });
                    await this.$services.alunosService.atualizarAluno({
                      ...aluno,
                      configuracao_id: this.user.configuracao_id,
                    });
                    this.$modals.close();
                    this.$toast.success("Aluno transferido com sucesso!");
                    this.$router.push({ name: "alunos" });
                  },
                  props: {
                    color: "success",
                    // text: true,
                    small: true,
                  },
                },
              ],
            });
          } else {
            this.$modals.info({
              title: "Este(a) aluno(a) já está cadastrado na sua escola!",
              message: "Verificamos que este(a) aluno(a) já está cadastrado na sua escola, ",
              buttons: [
                {
                  text: "Confirmar",
                  callback: () => {
                    this.$modals.close();
                    this.$toast.info("Este(a) aluno(a) já está cadastrado na sua escola");
                    this.$router.push({ name: "alunos" });
                  },
                  props: {
                    color: "success",
                    small: true,
                  },
                },
              ],
            });
          }
        }
      } catch (error) {
        this.$handleError(error);
      }
      this.pesquisandoINEP = false;
    },
    atualizarImagemAluno(event) {
      this.imgAlunoUrl = event.url;
      this.imgAlunoName = event.name;
    },

    atualizarImagemCarteira(event) {
      this.imgCarteiraUrl = event.url;
      this.imgCarteiraName = event.name;
    },

    async verificarCpfExistente() {
      if (!this.form.cpf || this.form.cpf.replace(/[^\d]/g, "").length !== 11) {
        this.cpfJaExiste = false;
        return;
      }

      this.verificandoCpf = true;

      try {
        const result = await this.$services.alunosService.verificarCpfGlobal(this.form.cpf);

        if (result.existe) {
          if (this.editing && result.tipo === "aluno" && result.dados.id === this.form.id) {
            this.cpfJaExiste = false;
            this.verificandoCpf = false;
            return;
          }

          this.cpfJaExiste = true;
          this.cpfTipoEncontrado = result.tipo;
          this.cpfDadosEncontrados = result.dados;
          this.mostrarModalCpfDuplicado = true;
        } else {
          this.cpfJaExiste = false;
        }
      } catch (error) {
        this.cpfJaExiste = false;
      }

      this.verificandoCpf = false;
    },

    fecharModalCpf() {
      this.mostrarModalCpfDuplicado = false;
      this.form.cpf = "";
    },
  },
};
</script>

<style scoped></style>
